import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './components/SEO';

const resources = [
  {
    title: 'World Mathematics Team Championship (WMTC) Guide',
    summary: 'The World Mathematics Team Championship (WMTC) is a prestigious international team-based mathematics competition that brings together top students from around the world. Learn about the competition format, preparation strategies, and how to excel in this challenging mathematical contest.',
    category: 'WMTC Guide',
    image: '/wmtclogo.png',
    readTime: '4 min read',
    featured: true,
    link: 'https://drive.google.com/file/d/1JqJaZojhguvk9mQKhPpjsRMPJsQhhGeB/view?usp=sharing'
  },
  {
    title: 'Pakistan Math Team Announcement 2024',
    summary: 'We are thrilled to announce the Pakistan Math Team for 2024! These exceptional students have demonstrated outstanding mathematical talent and will represent Pakistan at international competitions. Stay tuned for updates on their journey and achievements.',
    category: 'Announcement',
    image: '/team picture.png',
    readTime: '3 min read',
    featured: true,
    link: '#'
  },
  {
    title: 'Campus Ambassador Program - Work with our team to select top talent from your community!',
    summary: 'Join our Campus Ambassador Program and play a crucial role in discovering and nurturing Pakistan\'s brightest talents. As a campus ambassador, you\'ll help identify promising students, promote our competitions, and contribute to building a stronger academic community.',
    category: 'Program',
    image: '/group.png',
    readTime: '4 min read'
  },
  {
    title: 'Benefits for Students - Stretching Intellectual Boundaries',
    summary: 'Participating in Capstone\'s nationwide academic competitions offers students a unique opportunity to stretch their intellectual boundaries and discover their potential. These competitions not only encourage a deep understanding of various subjects but also promote critical thinking and problem-solving skills.',
    category: 'Student Benefits',
    image: '/WhatsApp Image 2024-09-27 at 8.03.42 AM.png',
    readTime: '6 min read'
  },
  {
    title: 'Benefits for Educators - Shaping Future Experts',
    summary: 'Educators can get involved in academic competitions to gain valuable experience and recognition in their fields. By mentoring and guiding the students, they play a pivotal role in shaping the future experts of their disciplines.',
    category: 'Educator Benefits',
    image: '/WhatsApp Image 2024-09-27 at 8.03.41 AM.png',
    readTime: '5 min read'
  }
];

const testimonials = [
  {
    name: 'Ibrahim Kashif',
    school: 'LGS (JT)',
    text: 'This competition was brought up to me by my friend, and not really knowring what it was, I participated. As I delved deeper into the competition, I saw how they had woven delicate intricacies into the complex question. It was great fun, collectively thinking and deciphering the problem statement.',
    image: '/ibrahim kashif.png'
  }
];

const campusAmbassadors = [
  'Sham kumar (Foundation Public School)',
  'Murtaza Ahmed (The City School)',
  'Muhammad Huzaifa (Beaconhouse)',
  'Shaheera Kashif (FAST NUCES University)',
  'Unaiza Afzal (Government College of Science)',
  'Umaan ubaid (City school ravi campus)',
  'Muhammad Aadil Chaudhary (ISL Pine Avenue)',
  'Unaiza Afzal (Punjab Group of Colleges)',
  'Fajar Amjad (Beconhouse College Program (BCP) Faisalabad)',
  'Fatima Noor Jawad (Beaconhouse Margalla Campus)',
  'Burhan Abeed (BSS JTC)',
  'Mamoona Raza (Froebel\'s International School)',
  'Fatima Nisar (Punjab college ayub park campus)',
  'Mehwish khan (APSACS Boys wing Chaklala Garrison scheme 3)'
];

const participatingSchools = [
  'Aitchison College',
  'Beaconhouse',
  'Froebel\'s International School',
  'Government Boys Degree College',
  'International School Lahore',
  'Karachi Grammar School',
  'LACAS',
  'Lahore Grammar School',
  'Lahore Grammar School For Boys (LGS-JT)',
  'Nixor College',
  'Roots Millennium School',
  'The City School'
];

export default function Blogs() {
  // SEO Data for Resources page
  const seoData = {
    title: "Blogs & Resources",
    description: "Access comprehensive guides for PMMC, PGEO, and WMTC competitions. Find student testimonials, campus ambassador information, and resources for academic excellence.",
    keywords: "PMMC guide, PGEO guide, WMTC guide, Pakistan Mathematical Modeling Challenge, Pakistan Geography Olympiad, academic competition resources, student testimonials, campus ambassadors",
    structuredData: []
  };

  return (
    <>
      <SEO {...seoData} />
      <div className="min-h-screen bg-white">
        {/* Hero Section - matches navbar color */}
        <section className="relative py-20 lg:py-32 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700" />
          
          <div className="relative max-w-7xl mx-auto px-6">
            <div className="text-center">
              <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
                Resources & Guides
              </h1>
              <p className="text-xl lg:text-2xl text-white/90 leading-relaxed max-w-4xl mx-auto">
                
              </p>
            </div>
          </div>
        </section>

        {/* Student Testimonial Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                Student Testimonials
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
                Hear from our participants 
              </p>
            </div>
            
            <div className="bg-white rounded-[20px] p-8 lg:p-12 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
              {testimonials.map((testimonial, i) => (
                <div key={i} className="text-center">
                  <div className="flex justify-center mb-6">
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name}
                      className="w-20 h-20 rounded-full object-cover border-2 border-teal-100 shadow-sm"
                    />
                  </div>
                  <blockquote className="text-xl lg:text-2xl text-gray-700 leading-relaxed mb-6 italic">
                    "{testimonial.text}"
                  </blockquote>
                  <div className="text-lg font-semibold text-gray-900">{testimonial.name}</div>
                  <div className="text-gray-600">{testimonial.school}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Assessment Guides Section - Purple Theme */}
        <section className="py-20 bg-gradient-to-r from-blue-600 via-purple-600 to-blue-800">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
                Assessment Guides
              </h2>
              <p className="text-xl lg:text-2xl text-white/90 leading-relaxed max-w-3xl mx-auto">
                Everything you need to know about participating in our competitions
              </p>
            </div>
            <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto justify-items-center">
              <div className="bg-blue-500 rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 transform hover:scale-105 transition-all duration-300 w-full max-w-md">
                <div className="text-center mb-6">
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2">WMTC Guide</h3>
                  <p className="text-white/90">Step-by-step instructions for the Mathematical Modeling Challenge</p>
                </div>
                <div className="text-center">
                  <a href="https://drive.google.com/file/d/1JqJaZojhguvk9mQKhPpjsRMPJsQhhGeB/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-block px-6 py-3 bg-white hover:bg-gray-100 text-blue-600 font-semibold rounded-lg transition-colors duration-200">
                    View Guide
                  </a>
                </div>
              </div>
              <div className="bg-green-500 rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 transform hover:scale-105 transition-all duration-300 w-full max-w-md">
                <div className="text-center mb-6">
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2">PGEO Guide</h3>
                  <p className="text-white/90">Step-by-step instructions for the Pakistan Geography Olympiad</p>
                </div>
                <div className="text-center">
                  <a href="/pgeo" className="inline-block px-6 py-3 bg-white hover:bg-gray-100 text-green-600 font-semibold rounded-lg transition-colors duration-200">
                    View Guide
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Campus Ambassador Program Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                  Campus Ambassador Program
                </h2>
                <p className="text-xl text-gray-600 leading-relaxed mb-8">
                  Work with our team to select top talent from your community! Join our Campus Ambassador Program and play a crucial role in discovering and nurturing Pakistan's brightest talents.
                </p>
                <a 
                  href="https://docs.google.com/forms/d/e/1FAIpQLSc5ehpIcyftzyjp_8YAgPVIzr_f0R4coX91FXhGVqEBtA_6zQ/closedform" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-block px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                >
                  Apply Now
                </a>
              </div>
              
              <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Our Campus Ambassadors</h3>
                <div className="space-y-3">
                  {campusAmbassadors.map((ambassador, i) => (
                    <div key={i} className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                      <span className="text-gray-700">{ambassador}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Participating Schools Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                Participating Schools
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
                Join the prestigious network of schools participating in our academic competitions
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {participatingSchools.map((school, i) => (
                <div key={i} className="bg-gray-50 rounded-2xl p-6 text-center hover:bg-blue-50 transition-colors duration-200">
                  <div className="text-lg font-semibold text-gray-900">{school}</div>
                </div>
              ))}
            </div>
            
            <div className="text-center mt-8">
              <p className="text-gray-600">And more...</p>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-20 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
                Benefits for Students
              </h2>
              <p className="text-xl text-white/90 leading-relaxed max-w-3xl mx-auto">
                Participating in Capstone's nationwide academic competitions offers students a unique opportunity to stretch their intellectual boundaries and discover their potential.
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">For Students</h3>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Opportunity to compete at international levels</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Recognition and certificates for achievements</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Networking with like-minded peers</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Enhanced problem-solving and critical thinking skills</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Potential scholarships and career opportunities</span>
                  </div>
                </div>
              </div>
              
              <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">For Educators</h3>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-purple-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Gain valuable experience and recognition</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-purple-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Play a pivotal role in shaping future experts</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-purple-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Mentor and guide talented students</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-purple-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Contribute to building a stronger academic community</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-purple-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Partner with us on our mission</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-black">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
              Ready to Join Our Challenges?
            </h2>
            <p className="text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto mb-12">
              Discover your potential and represent Pakistan on the world stage
            </p>
            <div className="flex flex-col md:flex-row gap-6 justify-center">
              <Link 
                to="/competitions/pmmc" 
                className="inline-block px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                Join PMMC
              </Link>
              <Link 
                to="/competitions/wmtc" 
                className="inline-block px-8 py-4 bg-green-600 hover:bg-green-700 text-white font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                Join WMTC
              </Link>
              <Link 
                to="/competitions/pgo" 
                className="inline-block px-8 py-4 bg-purple-600 hover:bg-purple-700 text-white font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                Join PGEO
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
} 